<div class="data-content">
    <div class="kit-card">
        <div class="kit-card-header">
            <nz-icon nzType="appstore" class="kit-card-icon" />
            <span class="kit-card-title">{{'produtokit.title'|translateTA}}</span>
        </div>

        <div class="kit-card-content">
            <simple-datagrid entityName="Mktpkit" [parentRow]="data" [condition]="condition" compact="true"></simple-datagrid>
        </div>

        <div class="kit-card-actions">
            <button nz-button nzType="primary" (click)="fechar()">{{'close'|translateTA}}</button>
        </div>
    </div>
</div>
